import * as ActionType from '../../constants/actionType';

export function setLabwareState(labwareState) {
  return {type: ActionType.SET_LABWARE_STATE, labwareState};
}

export function setLabware(labwarePos, labware) {
  return {type: ActionType.SET_LABWARE, labwarePos, labware};
}

export function removeLabware(labwarePos) {
  return {type: ActionType.REMOVE_LABWARE, labwarePos};
}

export function switchLabware(labwarePos1, labwarePos2) {
  return {type: ActionType.SWITCH_LABWARE, labwarePos1, labwarePos2};
}

export function renameLabware(labwarePos, name) {
  return {type: ActionType.RENAME_LABWARE, labwarePos, name};
}

export function selectLabware(labwarePos) {
  return {type: ActionType.SELECT_LABWARE, labwarePos};
}

export function unselectLabware(labwarePos) {
  return {type: ActionType.UNSELECT_LABWARE, labwarePos};
}

export function unselectAllLabware() {
  return {type: ActionType.UNSELECT_ALL_LABWARE};
}

export function restoreLabwareState(state) {
  return {type: ActionType.RESTORE_LABWARESTATE, state};
}

export function resetLabwareState() {
  return {type: ActionType.RESET_LABWARESTATE};
}

export function setLabwareBarcode(labwarePos, barcode) {
  return {type: ActionType.SET_LABWARE_BARCODE, labwarePos, barcode};
}
